import { Component, Input } from '@angular/core';
import { LoginService } from '../Services/login.service';

@Component({
  selector: 'np-tooltip-presenter',
  templateUrl: './tooltip-presenter.component.html',
  styleUrls: ['./tooltip-presenter.component.css']
})
export class TooltipPresenterComponent {

  @Input() text!: string;
  @Input() target?: Element;

  constructor(private loginService: LoginService) {

  }

  public get showProTooltips() {
    return this.loginService.showToolTips;
  }
}
